import type { OptimizationInput } from '../types/optimization'
import { optionalConstraintNumber } from './optimizationFormSettings'

export type PreparationTab = 'cargaison' | 'equipement' | 'regles'
export interface PreparationIssue {
  tab: PreparationTab
  message: string
  itemIndex?: number
  field?: string
}
const positive = (value: unknown) => typeof value === 'number' && Number.isFinite(value) && value > 0

/** Input completeness only; technical compliance belongs to the calculated result. */
export function optimizationReadiness(input: Partial<OptimizationInput>): PreparationIssue[] {
  const issues: PreparationIssue[] = []
  if (!input.items?.length) issues.push({ tab: 'cargaison', message: 'Ajoutez au moins un article à la cargaison.' })
  input.items?.forEach((item, itemIndex) => {
    const prefix = `Ligne ${itemIndex + 1} · ${item.id || 'Article sans référence'}`
    const add = (field: string, message: string) => issues.push({ tab: 'cargaison', itemIndex, field, message: `${prefix} : ${message}` })
    if (!item.id?.trim()) add('id', 'renseignez la référence article.')
    for (const [field, label] of [['length', 'longueur'], ['width', 'largeur'], ['height', 'hauteur']] as const) {
      if (!positive(item[field])) add(field, `la ${label} doit être strictement positive.`)
    }
    if (typeof item.weight !== 'number' || !Number.isFinite(item.weight) || item.weight < 0) add('weight', 'renseignez un poids positif ou nul.')
    const quantity = item.quantity ?? 1
    if (!positive(quantity) || !Number.isInteger(quantity)) add('quantity', 'la quantité doit être un nombre entier supérieur à zéro.')
  })
  if (!input.loadSpace || !(['length', 'width', 'height'] as const).every(key => positive(input.loadSpace?.[key]))) {
    issues.push({ tab: 'equipement', message: 'Renseignez les trois dimensions intérieures de l’espace de chargement, strictement positives.' })
  }
  const pressure = optionalConstraintNumber(input.constraints?.maxFloorPressure)
  if (pressure !== undefined && (!Number.isFinite(pressure) || pressure <= 0)) {
    issues.push({ tab: 'regles', message: 'La limite de pression au sol doit être strictement positive, ou laissée vide.' })
  }
  const margin = input.constraints?.axleLoadSafetyMarginPercent
  if (margin !== undefined && (!Number.isFinite(margin) || margin < 0 || margin > 1)) {
    issues.push({ tab: 'regles', message: 'La marge de sécurité essieux doit être comprise entre 0 et 100 %.' })
  }
  return issues
}

export function projectRunSelection(selected: ReadonlySet<string>, runs: ReadonlyArray<{ id: string }> = []) {
  return new Set(runs.filter(run => selected.has(run.id)).map(run => run.id))
}
